<template>
    <div class="container">
        <div class="toolbar shadow-sm">
            <img src="@/assets/icons/ConfigurationIcon.png" />
            <span class="title">{{ $t("admin.system.title") }}</span>
            <!-- <button :class="publishersButtonClass" v-on:click="handlePublishersButtonClicked()">{{ $t("admin.system.publishers_button") }}</button> -->
        </div>
        <div class="content-container">
            <PublisherEditor v-if="selectedToolbarButtonId == 'publishers'" />
        </div>
    </div>
</template>

<script>
import PublisherEditor from "./PublisherEditor.vue";

export default {
    components: {
        PublisherEditor
    },

    computed: {
        publishersButtonClass() {
            return "btn btn-outline-primary btn-sm" + (this.selectedToolbarButtonId == "publishers" ? " active": "");
        }
    },

    data() {
        return {
            selectedToolbarButtonId: "publishers"
        }
    },

    methods: {

    },

    mounted() {

    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    margin: 0px;
    margin-bottom: 16px;
    width: 100%;
    max-width: none;
}

.toolbar {
    background-color: #ffffff;
    margin-bottom: 8px;
    padding: 8px;
    padding-left: 24px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar .title {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin-right: 36px;
    max-width: 250px;
}

.toolbar button {
    margin: 0px 4px;
}

.content-container {
    margin: 0 auto;
    overflow: scroll;
    text-align: left;
    width: 100%;
    height: 100%;
}
</style>